/**
 * Anotações (TB02130 OBSVG) no modal de detalhes da OS.
 */

import { useState, useCallback, useEffect } from 'react';
import { getApiBaseUrl } from '../../../utils/apiConfig';

function authHeaders() {
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem('authToken') : null;
  return {
    Authorization: token ? `Bearer ${token}` : '',
    'Content-Type': 'application/json',
  };
}

export function useOrderDetailsNotes(order) {
  const numeroOS = order?.id ?? order?.TB02115_CODIGO;
  const [notes, setNotes] = useState([]);
  const [hasNotes, setHasNotes] = useState(false);
  const [loadingNotes, setLoadingNotes] = useState(false);
  const [savingNote, setSavingNote] = useState(false);
  const [notesError, setNotesError] = useState(null);
  const [saveError, setSaveError] = useState(null);

  const fetchNotes = useCallback(async () => {
    if (!numeroOS) {
      setNotes([]);
      setHasNotes(false);
      return [];
    }
    setLoadingNotes(true);
    setNotesError(null);
    try {
      const res = await fetch(
        `${getApiBaseUrl()}/api/board/orders/${encodeURIComponent(numeroOS)}/observacoes`,
        { headers: authHeaders() }
      );
      const json = await res.json().catch(() => ({}));
      if (res.ok && json.success && Array.isArray(json.data)) {
        setNotes(json.data);
        setHasNotes(Boolean(json.hasNotes) || json.data.length > 0);
        return json.data;
      }
      setNotesError(json.message || 'Erro ao carregar anotações');
      setNotes([]);
      setHasNotes(false);
      return [];
    } catch (err) {
      setNotesError(err.message || 'Erro ao carregar anotações');
      setNotes([]);
      setHasNotes(false);
      return [];
    } finally {
      setLoadingNotes(false);
    }
  }, [numeroOS]);

  useEffect(() => {
    setNotes([]);
    setHasNotes(false);
    setNotesError(null);
    setSaveError(null);
  }, [numeroOS]);

  const submitNote = useCallback(
    async (obs) => {
      const texto = String(obs || '').trim();
      if (!numeroOS || !texto) return false;
      setSavingNote(true);
      setSaveError(null);
      try {
        const res = await fetch(
          `${getApiBaseUrl()}/api/board/orders/${encodeURIComponent(numeroOS)}/observacoes`,
          {
            method: 'POST',
            headers: authHeaders(),
            body: JSON.stringify({ obs: texto }),
          }
        );
        const json = await res.json().catch(() => ({}));
        if (res.ok && json.success) {
          await fetchNotes();
          return true;
        }
        setSaveError(json.message || 'Erro ao salvar anotação');
        return false;
      } catch (err) {
        setSaveError(err.message || 'Erro ao salvar anotação');
        return false;
      } finally {
        setSavingNote(false);
      }
    },
    [numeroOS, fetchNotes]
  );

  return {
    notes,
    hasNotes,
    loadingNotes,
    savingNote,
    notesError,
    saveError,
    fetchNotes,
    submitNote,
  };
}
